var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { executeOrderWrapper, } from '@/lib/executorHelpers/executeOrder/executeOrderWrapper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSession } from '@/contexts/LitSessionProvider';
import useGetWrappedWallet from '../auth/useGetWrappedWallet';
import { ChainId } from '@shared/utils/config/networks';
import { getUrls } from '@shared/utils/config/environment';
var useWithdrawAsset = function (_a) {
    var transferParams = _a.transferParams, quoteParams = _a.quoteParams;
    var _b = useSession(), PKP = _b.PKP, litSession = _b.litSession;
    var _c = useGetWrappedWallet(), getEVMWallet = _c.getEVMWallet, getSolanaWallet = _c.getSolanaWallet;
    var queryClient = useQueryClient();
    // mutation for withdraw funds
    var _d = useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var orderTypeConstructor, orderType, _executeOrderParams, _executeOrder, token, network, from_address, to_address, updateFromUrl, updateToUrl, updateNativeFromUrl, updateNativeToUrl, error_1;
            var _a;
            var _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!transferParams || !quoteParams)
                            throw new Error('mutateWithdrawOrder:error on params.');
                        orderTypeConstructor = function () {
                            var _a;
                            var type = 'WITHDRAW';
                            type += (transferParams === null || transferParams === void 0 ? void 0 : transferParams.network) == ChainId.SOLANA ? '_SOLANA' : '_EVM';
                            type += ((_a = quoteParams === null || quoteParams === void 0 ? void 0 : quoteParams.fees) === null || _a === void 0 ? void 0 : _a.sponsorUsd) > 0 ? '_SPONSORED' : '';
                            return type;
                        };
                        orderType = orderTypeConstructor();
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 5, , 6]);
                        _a = {
                            params: quoteParams,
                            sessionSigs: litSession,
                            pkp: __assign({}, PKP),
                            cloudWallet: PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
                            orderType: orderType,
                            transferParams: transferParams
                        };
                        return [4 /*yield*/, getSolanaWallet()];
                    case 2:
                        _a.keypair = _h.sent();
                        return [4 /*yield*/, getEVMWallet()];
                    case 3:
                        _executeOrderParams = (_a.signer = _h.sent(),
                            _a);
                        return [4 /*yield*/, executeOrderWrapper(__assign({}, _executeOrderParams))];
                    case 4:
                        _executeOrder = _h.sent();
                        token = transferParams === null || transferParams === void 0 ? void 0 : transferParams.token_address;
                        network = transferParams === null || transferParams === void 0 ? void 0 : transferParams.network;
                        from_address = network == ChainId.SOLANA
                            ? transferParams === null || transferParams === void 0 ? void 0 : transferParams.from_address
                            : (_b = transferParams === null || transferParams === void 0 ? void 0 : transferParams.from_address) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                        to_address = network == ChainId.SOLANA
                            ? transferParams === null || transferParams === void 0 ? void 0 : transferParams.to_address
                            : (_c = transferParams === null || transferParams === void 0 ? void 0 : transferParams.to_address) === null || _c === void 0 ? void 0 : _c.toLowerCase();
                        updateFromUrl = "".concat(getUrls().INDEXER_URL, "/jobs/index-balance-for-token?chain=").concat(network, "&wallet=").concat(from_address, "&token=").concat(token);
                        updateToUrl = "".concat(getUrls().INDEXER_URL, "/jobs/index-balance-for-token?chain=").concat(network, "&wallet=").concat(to_address, "&token=").concat(token);
                        updateNativeFromUrl = "".concat(getUrls().INDEXER_URL, "/jobs/index-balance-for-token?chain=").concat(network, "&wallet=").concat(from_address, "&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
                        updateNativeToUrl = "".concat(getUrls().INDEXER_URL, "/jobs/index-balance-for-token?chain=").concat(network, "&wallet=").concat(to_address, "&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
                        fetch(updateFromUrl);
                        fetch(updateToUrl);
                        fetch(updateNativeFromUrl);
                        fetch(updateNativeToUrl);
                        //   console.log('mutateWithdrawOrder:data', { data, _executeOrderParams });
                        if (((_e = (_d = _executeOrder === null || _executeOrder === void 0 ? void 0 : _executeOrder.result) === null || _d === void 0 ? void 0 : _d.decodedResponse) === null || _e === void 0 ? void 0 : _e.status) != 'success') {
                            throw new Error(((_g = (_f = _executeOrder === null || _executeOrder === void 0 ? void 0 : _executeOrder.result) === null || _f === void 0 ? void 0 : _f.decodedResponse) === null || _g === void 0 ? void 0 : _g.error) || 'Withdraw failed!');
                        }
                        // return new Promise((resolve) => setTimeout(resolve, 5000));
                        return [2 /*return*/, Promise.resolve({ data: _executeOrder })];
                    case 5:
                        error_1 = _h.sent();
                        throw new Error(error_1);
                    case 6: return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function (data) {
            console.log('mutateWithdrawOrder:SUCCESS', { data: data });
            // toast.success('Send Funds completed successfully');
        },
        onError: function () {
            //   toast.error('mutateWithdrawOrder: query error');
        },
    }), mutateWithdrawOrderData = _d.data, mutateWithdrawOrder = _d.mutate, isPendingMutateWithdrawOrder = _d.isPending, isSuccessMutateWithdrawOrder = _d.isSuccess, onErrorMutateWithdrawOrder = _d.error;
    return {
        mutateWithdrawOrderData: mutateWithdrawOrderData,
        mutateWithdrawOrder: mutateWithdrawOrder,
        isPendingMutateWithdrawOrder: isPendingMutateWithdrawOrder,
        isSuccessMutateWithdrawOrder: isSuccessMutateWithdrawOrder,
        onErrorMutateWithdrawOrder: onErrorMutateWithdrawOrder,
    };
};
export default useWithdrawAsset;
